import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotifierService } from '../../services/Notifierservice';
import Validation from '../../validation/confirm-password-validation';
import { VerifyService } from './service/verify.service';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { LoginService } from '../login/service/login.service';
import { MainService } from '../../views/layout/main/service/mainservice';
@Component({
  standalone: false,
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './verify.component.scss',
})
export class VerifyComponent implements OnInit {
  showBtn = false;
  emitVal = false;
  loginForm!: FormGroup;
  localValue: any;
  getEmailVerifyResponseData: any;
  permitedEmail: any;
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  showC = false;
  sign = true;
  tokens: any;
  spinner = false;
  showVerifyForm = 'verify';
  otpInput: any;
  submitted = false;
  loginSubmitted = false;
  passwordForm: FormGroup = new FormGroup({});
  receiveSgnVfy: any;
  submittedPassword: boolean = false;
  signup_verified: boolean = false;

  // ── CAPTCHA ──────────────────────────
  captchaText: string = '';
  captchaInput: string = '';
  captchaVerified: boolean = false;
  captchaSubmitted: boolean = false;
  // ─────────────────────────────────────

  authMode: string = '';
  passwordReset: boolean = false;
  userEmail: string = '';

  private readonly notifier: NotifierService;
  postData = {
    email: '',
    encrypted_data: '',
    pass_phrase: "6389U%$B*P*-'TD5",
    salt: "`W/Q`,1/N.CG'%3I",
  };

  @ViewChild('verifyOTP') verifyOTP!: ElementRef;
  @ViewChild('verifyOTPError') verifyOTPError!: ElementRef;
  @ViewChild('verifyOTPBtn') verifyOTPBtn!: ElementRef;
  @Input() set flowContext(
    data: {
      authMode: string;
      signupVerified?: boolean;
      passwordReset: boolean;
      email: string;
      directPasswordSetup?: boolean;
    } | null,
  ) {
    if (data) {
      this.authMode = data.authMode;
      this.signup_verified = data.signupVerified ?? false;
      this.passwordReset = data.passwordReset;
      this.userEmail = data.email;

      if (data.directPasswordSetup) {
        this.showVerifyForm = 'otp';
      }
    }
  }
  @Output() formChange: EventEmitter<any> = new EventEmitter();
  constructor(
    private readonly notifierService: NotifierService,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly verifyService: VerifyService,
    private readonly service: LoginService,
    private readonly renderer: Renderer2,
    private readonly mainService: MainService,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@!%*?&]).{8,}$/,
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      },
    );
    this.generateCaptcha();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  hideShowPassword(): void {
    this.isText = !this.isText;

    this.eyeIcon = this.isText ? 'fa-eye' : 'fa-eye-slash';
    this.type = this.isText ? 'text' : 'password';
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  goBack() {
    this.showBtn = false;
    this.formChange.emit('login');
  }

  submitOtp() {
    this.captchaSubmitted = true;
    if (!this.captchaVerified) return;

    const otp = this.otpInput?.toString().trim();
    const email = (this.userEmail || localStorage.getItem('loginuser')) ?? '';

    this.spinner = true;

    // ── OTP_ONLY + signup_verified TRUE ───────────────────────────
    // verifyOtpFlow → token → dashboard
    if (this.authMode === 'OTP_ONLY' && this.passwordReset) {
      this.verifyService.verifyOtpFlow(email, otp).subscribe({
        next: (response: any) => {
          sessionStorage.setItem('isLoggedIn', 'true');
          this.verifyService.verifyToken = response?.['token'];
          this.navigateToDashboard();
        },
        error: (err: any) => {
          this.spinner = false;
          this.generateCaptcha();
        },
      });
      return;
    }

    // ── OTP_ONLY + signup_verified FALSE ──────────────────────────
    // signupVerifyOtpLogin → token → set password screen
    if (this.authMode === 'OTP_ONLY' && !this.passwordReset) {
      this.verifyService.signupVerifyOtpLogin(email, otp).subscribe({
        next: (response: any) => {
          sessionStorage.setItem('isLoggedIn', 'true');
          this.verifyService.verifyToken = response?.['token'];
          this.showVerifyForm = 'otp'; // show set password form
          this.spinner = false;
        },
        error: (err: any) => {
          this.spinner = false;
          this.generateCaptcha();
        },
      });
      return;
    }

    // ── PASSWORD_ONLY + signup_verified FALSE ─────────────────────
    // signupVerifyOtpLogin → token → set password screen
    if (this.authMode === 'PASSWORD_ONLY' && !this.passwordReset) {
      this.verifyService.signupVerifyOtpLogin(email, otp).subscribe({
        next: (response: any) => {
          sessionStorage.setItem('isLoggedIn', 'true');
          this.verifyService.verifyToken = response?.['token'];
          this.showVerifyForm = 'otp'; // show set password form
          this.spinner = false;
        },
        error: (err: any) => {
          this.spinner = false;
          this.generateCaptcha();
        },
      });
      return;
    }

    // ── PASSWORD_OTP + signup_verified TRUE ───────────────────────
    // verifyOtpFlow → token → dashboard
    if (this.authMode === 'PASSWORD_OTP' && this.passwordReset) {
      this.verifyService.verifyOtpFlow(email, otp).subscribe({
        next: (response: any) => {
          sessionStorage.setItem('isLoggedIn', 'true');
          this.verifyService.verifyToken = response?.['token'];
          this.navigateToDashboard();
        },
        error: (err: any) => {
          this.spinner = false;
          this.generateCaptcha();
        },
      });
      return;
    }

    // ── PASSWORD_OTP + signup_verified FALSE ──────────────────────
    // signupVerifyOtpLogin → token → set password screen
    if (this.authMode === 'PASSWORD_OTP' && !this.passwordReset) {
      this.verifyService.signupVerifyOtpLogin(email, otp).subscribe({
        next: (response: any) => {
          sessionStorage.setItem('isLoggedIn', 'true');
          this.verifyService.verifyToken = response?.['token'];
          this.showVerifyForm = 'otp'; // show set password form
          this.spinner = false;
        },
        error: (err: any) => {
          this.spinner = false;
          this.generateCaptcha();
        },
      });
      return;
    }

    // ── Fallback: signup flow ────────────────────────────────────
    // ── Fallback: signup flow ────────────────────────────────────
    // ── Fallback: signup flow ────────────────────────────────────
    this.verifyService.signupVerifyOtpLogin(email, otp).subscribe({
      next: (response: any) => {
        sessionStorage.setItem('isLoggedIn', 'true');
        this.verifyService.verifyToken = response?.['token'];
        this.navigateToDashboard();
        this.spinner = false;
      },
      error: (err: any) => {
        this.spinner = false;
        this.generateCaptcha();
      },
    });
  }

  async onSubmit(): Promise<void> {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }

    const values = this.passwordForm.value;
    const email = localStorage.getItem('loginuser');
    const password = values.password;

    try {
      // ── Encrypt password using Web Crypto (matches signIn) ──
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const passPhrase = this.makeRandom(16, possible);
      const salt = this.makeRandom(16, possible);
      const enc = new TextEncoder();

      const keyMaterial = await crypto.subtle.importKey(
        'raw',
        enc.encode(passPhrase),
        { name: 'PBKDF2' },
        false,
        ['deriveKey'],
      );

      const aesKey = await crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: enc.encode(salt),
          iterations: 100_000,
          hash: 'SHA-256',
        },
        keyMaterial,
        { name: 'AES-GCM', length: 256 },
        false,
        ['encrypt'],
      );

      const iv = crypto.getRandomValues(new Uint8Array(12));

      const ciphertextBuffer = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        aesKey,
        enc.encode(password),
      );

      // Prepend IV to ciphertext, then base64-encode
      const combined = new Uint8Array(
        iv.byteLength + ciphertextBuffer.byteLength,
      );
      combined.set(iv, 0);
      combined.set(new Uint8Array(ciphertextBuffer), iv.byteLength);
      const encryptedData = btoa(
        Array.from(combined)
          .map((b) => String.fromCharCode(b))
          .join(''),
      );

      const formEncrypt = {
        email: email?.trim(),
        encrypted_data: encryptedData,
        salt: salt,
        pass_phrase: passPhrase,
      };

      this.spinner = true;

      this.verifyService.postPassword(formEncrypt).subscribe({
        next: (response: any) => {
          this.showVerifyForm = 'passwordSuccess';
          this.verifyService.verifyToken = '';
          this.spinner = false;
          this.submitted = false;
          this.isText = false;
        },
        error: (err: any) => {
          this.spinner = false;
        },
      });
    } catch (error) {
      console.error('Encryption error:', error);
      this.spinner = false;
    }
  }

  ngAfterViewInit() {
    this.renderer.setStyle(
      this.verifyOTPError.nativeElement,
      'display',
      'none',
    );
    this.renderer.setAttribute(
      this.verifyOTPBtn.nativeElement,
      'disabled',
      'true',
    );

    this.renderer.listen(
      this.verifyOTP.nativeElement,
      'input',
      (event: any) => {
        const input = event.target as HTMLInputElement;

        // Strip all non-digit and space characters in-place (no setTimeout)
        const cleaned = input.value.replace(/[^0-9]/g, '');
        input.value = cleaned;
        this.otpInput = cleaned; // keep ngModel in sync

        if (cleaned.length === 0) {
          this.renderer.setStyle(
            this.verifyOTPError.nativeElement,
            'display',
            'none',
          );
          this.renderer.setAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
            'true',
          );
        } else {
          this.renderer.setStyle(
            this.verifyOTPError.nativeElement,
            'display',
            'none',
          );
          this.renderer.removeAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
          );
        }
      },
    );

    // Handle paste explicitly to strip non-digits
    this.renderer.listen(
      this.verifyOTP.nativeElement,
      'paste',
      (event: ClipboardEvent) => {
        event.preventDefault();
        const pasted = event.clipboardData?.getData('text') ?? '';
        const cleaned = pasted.replace(/[^0-9]/g, '');
        const input = this.verifyOTP.nativeElement as HTMLInputElement;
        input.value = cleaned;
        this.otpInput = cleaned;

        if (cleaned.length > 0) {
          this.renderer.removeAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
          );
        }
      },
    );
  }

  generateCaptcha(): void {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
    this.captchaText = Array.from(
      { length: 6 },
      () => chars[Math.floor(Math.random() * chars.length)],
    ).join('');
    this.captchaVerified = false;
    this.captchaInput = '';
    this.captchaSubmitted = false;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.drawCaptcha());
    });
  }

  drawCaptcha(): void {
    const canvas = document.getElementById(
      'captchaCanvas',
    ) as HTMLCanvasElement;
    if (!canvas) return;
    const ctx = canvas.getContext('2d')!;
    canvas.width = 180;
    canvas.height = 44;

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 180, 44);

    for (let i = 0; i < 4; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * 180, Math.random() * 44);
      ctx.lineTo(Math.random() * 180, Math.random() * 44);
      ctx.strokeStyle = `hsla(${Math.random() * 360}, 30%, 75%, 0.5)`;
      ctx.lineWidth = 1;
      ctx.stroke();
    }

    const colors = [
      '#1a56db',
      '#0f6e56',
      '#993c1d',
      '#534ab7',
      '#72243e',
      '#3b6d11',
    ];
    this.captchaText.split('').forEach((ch, i) => {
      ctx.save();
      const x = 18 + i * 26;
      const y = 28 + (Math.random() * 6 - 3);
      ctx.translate(x, y);
      ctx.rotate((Math.random() - 0.5) * 0.35);
      ctx.font = `600 22px system-ui, -apple-system, sans-serif`;
      ctx.fillStyle = colors[i % colors.length];
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    for (let i = 0; i < 25; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * 180, Math.random() * 44, 0.8, 0, 2 * Math.PI);
      ctx.fillStyle = 'rgba(0,0,0,0.06)';
      ctx.fill();
    }
  }

  verifyCaptcha(): void {
    this.captchaVerified = this.captchaInput.trim() === this.captchaText;
  }

  private navigateToDashboard(): void {
    const email = (this.userEmail || localStorage.getItem('loginuser')) ?? '';

    this.service.getUser().subscribe({
      next: (response: any) => {
        if (!response?.id || !response.is_active) {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigateByUrl('login');
          this.spinner = false;
          return;
        }

        const userSalt = CryptoJS.lib.WordArray.random(16);
        const userIv = CryptoJS.lib.WordArray.random(16);
        const userKey = CryptoJS.PBKDF2(this.service.enCryptKey, userSalt, {
          keySize: 32,
          iterations: 128,
          hasher: CryptoJS.algo.SHA256,
        });
        const encryptedUser = CryptoJS.AES.encrypt(
          JSON.stringify(response),
          userKey,
          { iv: userIv },
        );
        const storedUser =
          userSalt.toString() +
          '::' +
          userIv.toString() +
          '::' +
          encryptedUser.toString();

        localStorage.setItem('loginuser', email);
        localStorage.setItem('user', storedUser);
        this.service.userDetails = response;
        this.service.isAuthorizedUser = true;
        this.router.navigateByUrl('main/rfpcontracts');
        localStorage.setItem('selectedApps', 'rfpcontract');

        this.mainService.selectedAppsBS.next({
          text: 'Document Analytics and Process Automation',
          icon: 'bi bi-file-earmark',
          url: '/main/rfpcontracts',
          name: 'rfpcontract',
        });
        this.spinner = false;
      },
      error: () => {
        this.spinner = false;
        this.router.navigateByUrl('login');
      },
    });
  }
}
